import axiosInstance from '../axiosInterceptor/axiosInstance'

// The org's calendar, or one of its teams' when a team is given.
const getEvents = async (data) => {
  const { teams, org, startDateTime, endDateTime, stageId, groupId, seasonId } = data
  if (!org) return null

  const teamQueryString = teams ? `&teamId=${teams}` : ''
  const seasonQueryString = seasonId ? `&seasonId=${seasonId}` : ''
  const stageQueryString = stageId ? `&stageId=${stageId}` : ''
  const groupQueryString = groupId ? `&groupId=${groupId}` : ''

  const queryString = `?startDateTime=${startDateTime}&endDateTime=${endDateTime}${teamQueryString}${seasonQueryString}${stageQueryString}${groupQueryString}`

  const url = `v1/orgs/${org}/events${queryString}`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getEvents
